module.exports = __webpack_public_path__ + "media/images/logoactiva-8f39d66f.png";